/**
 * FiltersContainer component
 * @returns <FiltersContainer />
 */

const FiltersContainer = ({ children }) => {
  return (
    <div className="store-grid__container__filters">
      {children}
    </div>
  )
}

export default FiltersContainer